import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

export const Route = createRootRoute({
  component: Root,
});

export default function Root() {
  return (
    <div className="flex h-screen w-screen flex-col overflow-hidden bg-background antialiased">
      <main className="min-h-0 flex-1 overflow-auto">
        <Outlet />
        <TanStackRouterDevtools />
      </main>
    </div>
  );
}
